import Vue from 'vue'
import baseMixin from './base'
import contentMixins from './content'

Vue.mixin(baseMixin)
Vue.mixin(contentMixins)
